import React, { FC } from 'react';
import Button from '../../../Button';
import imgURL from '../../../../lib/imgURL';
import Props from './typing';

const Slide: FC<Props> = (props): JSX.Element => {
  const {
    slide,
    currentStep,
    setCurrentStep,
    closeModal,
    islastSlide,
    currentSlideNo,
    lastSlideNo,
  } = props;

  return (
    <div className='slide'>
      <div className='slide-img'>
        <img src={imgURL[slide?.img]} alt={slide?.img} width={'95%'} />
      </div>
      <div className='slide-content'>
        <div className='slide-title'>{slide?.title}</div>
        <div className='slide-description'>
          {slide?.description?.lines.map((line, index) => (
            <p key={index}>{line}</p>
          ))}

          {slide?.description?.link ? (
            <p className='slide-link'>
              <a
                href={slide?.description?.link}
                target='_blank'
                rel='noreferrer'
              >
                Watch a YouTube video
              </a>
            </p>
          ) : (
            ''
          )}
        </div>
        <div className='btn-section'>
          <Button
            btnStyleClass='slide-prev-btn'
            label='Previous'
            enable={currentStep > 0}
            onClick={() => setCurrentStep(currentStep - 1)}
          />
          <div className='slide-number'>{`${currentSlideNo} of ${lastSlideNo}`}</div>

          <Button
            btnStyleClass='slide-next-btn'
            label={`${islastSlide ? 'Finish' : 'Next'}`}
            enable
            onClick={() => {
              islastSlide ? closeModal() : setCurrentStep(currentStep + 1);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Slide;
